<template>
  <b-container>
    <h1><img src="../assets/OK.svg">{{ $t('wifi.successTitle') }}</h1>
    <h5 class="pb-4">{{ $t('wifi.successMessage') }} <b>{{ wifi }}</b>.</h5>
    <b-button v-if="sn === ''" variant="primary" v-on:click="$emit('register')">{{ $t('registerSensor') }} </b-button>
    <b-button v-else variant="primary" v-on:click="$emit('restart')">{{ $t('restartSetup') }}</b-button>
  </b-container>
</template>

<script>
export default {
  name: 'SetupWifiSuccess',
  props: ['wifi', 'sn'],
  data() {
    return {};
  },
}
</script>
